import React from 'react'
import MuiBadge from '@material-ui/core/Badge'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

const StyledMuiBadge = withStyles(theme => ({
  colorPrimary: {
    backgroundColor: props => props.badgeBackgroundColor || theme.palette.badgeBackgroundColor,
  },
  badge: {
    fontSize: '10px'
  }
}))(MuiBadge)

/**
 * Implements Mui Badge.
 *
 * @param {object} props component props
 * @returns {Badge} Badge component
 */
const Badge = props => {
  return (
    <span style={{ cursor: props.onClick ? 'pointer' : undefined }}>
      <StyledMuiBadge onClick={props.onClick} color='primary' {...props} overlap={props.overlap || 'circular'} badgeContent={props.badgeContent} max={props.max} >
        {props.children}
      </StyledMuiBadge>
    </span>
  )
}

Badge.propTypes = {
  /**
   id for the control.
   */
  id: PropTypes.string,
  /**
   Wrapped shape the badge should overlap.
   */
  overlap: PropTypes.oneOf(['circular', 'rectangular']),
  /**
   The content rendered within the badge.
   */
  badgeContent: PropTypes.string.isRequired,
  /**
   The icon for the badge.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  /**
   The max number to display for the badge.
   */
  max: PropTypes.number,
  /**
   Function that is executed when the badge is clicked.
   */
  onClick: PropTypes.func
}

Badge.defaultProps = {
  overlap: 'circular',
  max: 99,
}

export default Badge